module.exports = __webpack_public_path__ + "img/icon_macbook.b11d7d38.png";